module.exports = __webpack_public_path__ + "img/send_new_message.f5a29fb9.svg";